import type { ConfigPriceFormValues, PriceSegmentRow } from './configPriceModel'

type SegmentColumnRow = Pick<
  PriceSegmentRow,
  'segmentId' | 'enabled' | 'mode' | 'columnNumber'
>

const isColumnSegment = (row: SegmentColumnRow) =>
  row.enabled && row.mode === 'COLUMN' && row.columnNumber.trim() !== ''

export const getSegmentIdsByColumn = (rows: SegmentColumnRow[]) =>
  rows.reduce<Record<number, string[]>>((result, row) => {
    if (!isColumnSegment(row)) return result
    const columnIndex = Number(row.columnNumber) - 1
    return {
      ...result,
      [columnIndex]: [...(result[columnIndex] ?? []), row.segmentId],
    }
  }, {})

export const assignSegmentColumn = (
  rows: PriceSegmentRow[],
  columnNumber: string,
  segmentIds: string[]
): PriceSegmentRow[] =>
  rows.map((row) => {
    if (segmentIds.includes(row.segmentId))
      return { ...row, enabled: true, mode: 'COLUMN', columnNumber }
    if (row.mode === 'COLUMN' && row.columnNumber === columnNumber)
      return {
        ...row,
        mode: row.isRrc ? 'RRC_COLUMN' : 'MARKUP',
        columnNumber: '',
      }
    return row
  })

export const hasPriceSourceColumn = (
  values: Pick<
    ConfigPriceFormValues,
    'purchaseColumnNumber' | 'rrcColumnNumber' | 'segments'
  >
) =>
  values.purchaseColumnNumber.trim() !== '' ||
  values.rrcColumnNumber.trim() !== '' ||
  values.segments.some(isColumnSegment)
